module.exports = __webpack_public_path__ + "static/img/Team 2.df3aec4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hr/Team 2.png
// module id = /Zch
// module chunks = 2